export enum InvoiceDiscountVat {
  PreVat = 'preVAT',
  PostVat = 'postVAT',
}
